<template>
  <figure :class="`c-image c-image--${alignClass}`">
    <header class="c-image__title" v-if="title" v-html="title" />
    <img class="c-image__media" v-if="image.url" :src="image.url" :alt="image.alt" :width="image.width" :height="image.height">
    <figcaption class="c-image__caption" v-if="caption" v-html="caption" />
  </figure>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'content-image',
  props: ['content'],
  computed: {
    alignClass () {
      return this.content.primary.align ? this.toCssName(this.content.primary.align) : 'none'
    },
    caption () {
      return this.content.primary.caption ? PrismicDOM.RichText.asHtml(this.content.primary.caption) : null
    },
    title () {
      return this.content.primary.title ? PrismicDOM.RichText.asHtml(this.content.primary.title) : null
    },
    image () {
      if (this.content.primary.image.url) {
        return {
          url: this.content.primary.image.url,
          alt: this.content.primary.image.alt,
          width: this.content.primary.image.dimensions.width,
          height: this.content.primary.image.dimensions.height
        }
      }
    },
    mobileImage () {
      if (this.content.primary.image.mobile && this.content.primary.image.mobile.url) {
        return {
          url: this.content.primary.image.mobile.url,
          alt: this.content.primary.image.mobile.alt,
          width: this.content.primary.image.mobile.dimensions.width,
          height: this.content.primary.image.mobile.dimensions.height
        }
      }
    }
  },
  methods: {
    toCssName (str) {
      return str.replace(/\s+/g, '-').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
  .c-image {
    margin-bottom: 1rem;
  }

  .c-image--right,
  .c-image--left,
  .c-image--center {
    @media (min-width: $breakpoint-md) {
       width: 50%;
       max-width: 500px;
    }
  }

  .c-image--center {
    margin-left: auto;
    margin-right: auto;
  }

  .c-image--right {
    @media (min-width: $breakpoint-md) {
       float: right;
       margin-left: 1rem;
    }
  }

  .c-image--left {
    @media (min-width: $breakpoint-md) {
       float: left;
       margin-right: 1rem;
    }
  }

  .c-image--full-width {
    text-align: center;
  }

  .c-image__title {
    max-width: $content-width;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .c-image_media {
    display: block;
  }

  .c-image__caption {
    padding: 5px;
    font-style: italic;
    font-size: .9rem;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Image.vue?010d1c02